<template>
  <loader :task="task" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Loader from '@/components/loading/AsyncLinearProgress.vue';
import { AppUser } from '@/type';
import { decodeJWT } from '@/utils';
import { login } from '.';

interface Data {
  task: Promise<AppUser>|null,
}

export default defineComponent({
  emits: ['expired', 'logged-in'],
  components: {
    Loader,
  },
  props: {
    accessToken: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  computed: {
    isExpired(): boolean {
      const claims = decodeJWT<AppUser>(this.accessToken);
      return ((claims.exp * 1000) <= Date.now());
    },
  },
  watch: {
    accessToken: {
      handler() {
        this.login();
      },
      immediate: true,
    },
  },
  methods: {
    login() {
      if (this.isExpired) {
        this.$emit('expired');
        return;
      }
      this.task = login(this.accessToken);
      this.task.then((appUser) => {
        this.$emit('logged-in', appUser);
      });
    },
  },
});
</script>
